<template>
  <div id="outsideReceipt" class="print-content">
    <div class="d-flex justify-content-between" style="color: #0056b3">
      <div>
        <h1
          style="font-size: 50px; font-weight: 800; color: #0056b3"
          class="fw-bold"
        >
          Al-Waziriya Hospital
        </h1>
        <div style="display: flex; gap: 10px">
          <div style="display: flex; flex-direction: column; margin-left: 20px">
            <h2 style="font-size: 33px; font-weight: 600; color: #0056b3">
              4253169
            </h2>
            <h2 style="font-size: 33px; font-weight: 600; color: #0056b3">
              4253167
            </h2>
          </div>
          <div
            style="
              align-items: center;
              display: flex;
              justify-content: center;
              flex-direction: column;
            "
          >
            <h2
              style="
                font-size: 33px;
                font-weight: 600;
                color: #0056b3;
                align-items: center;
                display: flex;
                justify-content: center;
                flex-direction: column;
                height: 100%;
              "
            >
              بدالة ذات خطين
            </h2>
          </div>
        </div>
      </div>
      <div class="" style="color: #0056b3">
        <h1
          style="font-size: 65px; font-weight: 800; color: #0056b3"
          class="w-100 d-flex justify-content-end"
        >
          مستشفى الوزيرية
        </h1>
        <div
          style="
            font-size: 65px;
            font-weight: 600;
            color: #0056b3;
            margin-top: 25px;
          "
        >
          <h2
            style="
              font-size: 54px;
              font-weight: 600;
              color: #0056b3;
              margin-top: 25px;
            "
            class="w-100 d-flex justify-content-end"
          >
            قسم الاجنة و اطفال الانابيب
          </h2>
        </div>
      </div>
    </div>
    <div
      class="mt-4 w-100 d-flex justify-content-between"
      style="align-items: center"
    >
      <div
        class="d-flex justify-content-end align-self-end align-items-end"
        style="font-size: 50px; color: #0056b3"
      >
        {{ getNestedProperty(data, 'date') }} :التاريخ
      </div>
      <div>
        <div style="display: flex; justify-content: center">
          <h1
            style="font-size: 60px; font-weight: 800; color: #0056b3"
            class="fw-bold"
          >
            المبلغ
          </h1>
        </div>

        <div
          class="border border-2 border-dark solid"
          style="
            border: 3px solid #0056b3;
            width: 400px;
            height: auto;
            border-radius: 10px;
            color: #0056b3;
          "
        >
          <h1
            style="font-size: 35px; font-weight: 800; color: #0056b3"
            class="fw-bold d-flex justify-content-center"
          >
            {{ formatUSDCurrency(getNestedProperty(data, 'amount_usd')) }}
          </h1>
        </div>
      </div>
    </div>
    <div
      class="mt-8 d-flex justify-content-center"
      style="
        margin-top: 10px;
        color: #0056b3;
        font-size: 60;
        text-decoration: underline;
      "
    >
      <span
        style="
          margin-top: 80px;
          color: #0056b3;
          font-size: 50px;
          font-weight: 600;
          text-decoration: underline;
        "
      >
        وصل قبض</span
      >
    </div>

    <div style="margin-top: 20px">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 43px;
              text-align: center;
              font-weight: 600;
              color: #0056b3;
            "
            >{{ formatIQDCurrency(getNestedProperty(data, 'amount_iqd')) }}</span
          >
        </div>
        <div style="font-size: 43px; font-weight: 600; color: #0056b3">
          :استلمت المبلغ
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 30px;
              text-align: center;
              font-weight: 300;
              color: #0056b3;
            "
            >{{ getNestedProperty(data, 'name') }}</span
          >
        </div>
        <div style="font-size: 43px; font-weight: 600; color: #0056b3">
          :الاسم
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 30px;
              text-align: center;
              font-weight: 300;
              color: #0056b3;
            "
            >{{ getNestedProperty(data, 'description') }}</span
          >
        </div>
        <div style="font-size: 43px; font-weight: 600; color: #0056b3">
          :عن اجراء
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <span style="font-size: 33px; font-weight: 600; color: #0056b3">
          المحاسب</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    formatIQDCurrency(value) {
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat('ar-IQ', {
        style: 'currency',
        currency: 'IQD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },
    formatUSDCurrency(value) {
      // Ensure the value is a number and format it to one decimal place
      const formattedValue = Number(value).toFixed(1);

      // Create a new Intl.NumberFormat object for USD currency without cents
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

      // Format the value and return it
      return formatter.format(formattedValue);
    },
    getNestedProperty(obj, path, defaultValue = "") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
     
      // console.log("result", result);
      return result;
    },
  },
};
</script>
<style scoped>
.print-content {
  display: none;
}
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }
  button {
    display: none; /* Hide the button when printing */
  }
}
p.solid {
  border-style: solid;
}
table {
  background-color: #333;
  width: 60%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #333;
}
th,
td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #333;
}
th {
  background-color: #f2f2f2;
}
tr:last-child td {
  border-bottom: none;
}
</style>
<!--  -->
